import React from "react";
import { useState, useEffect } from "react";

export const Timer = ({deadline, callback}) => {
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);

    const getTime = () => {
        const time = Date.parse(deadline) - Date.now();

        setHours(Math.floor((time / (1000 * 60 * 60)) % 24));
        setMinutes(Math.floor((time / 1000 / 60) % 60));
        setSeconds(Math.floor((time / 1000) % 60));
    };

    useEffect(() => {
        const interval = setInterval(() => getTime(deadline), 1000);

        return () => clearInterval(interval);
    }, []);

    const performCallback = () => {
        callback()
    }

    useEffect(() => {
        if (seconds === 0 && minutes === 0 && hours === 0) {
            performCallback()
            // console.log("CALL BACK HAS REACHED THIS POINT.")
        }
    }, [seconds])

    return (
        <div className="timer" role="timer">
                <div>
                    <span id="hour">{hours < 10 ? "0" + hours : hours}:</span>
                    <span id="minute">{minutes < 10 ? "0" + minutes : minutes}:</span>
                    <span id="second">{seconds < 10 ? "0" + seconds : seconds}</span>
                </div>
        </div>
    );
};